import React from 'react';
import { ReactComponent as Lut } from "./../images/LutLogo.svg";
import { ReactComponent as TSYS } from "./../images/TsysLogo.svg";
import { ReactComponent as FirstData } from "./../images/FirstDataLogo.svg";

function PricingStructureIcon(product:any) {
    const IconStyles = {
        height: "20px",
        width: "20px"
    };
    let selectedLogo;

    if (product.productName == "Lut Master Template") {
        selectedLogo = <Lut/>;
    } else if (product.productName == "Master Template") {
        selectedLogo = <TSYS/>;
    } else if (product.productName == "First Data Pricing Structure") {
        selectedLogo = <FirstData/>
    }
     else {
        selectedLogo = "--";
    }
    return (
        <div className='productIcon'>
           {selectedLogo}
        </div>
    )

}

export default PricingStructureIcon